import PaymentGetway from ".";

export const paymentGetwayRoutes = () => [
  {
    path: "/admin/payment-getway",
    title: "plans",
    layout: "admin",
    routeType: "admin",
    component: PaymentGetway,
  },
];
